import { faCreditCard, faTruck, faWarning } from '@fortawesome/pro-light-svg-icons'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import ITHeaderText from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { UserPermissionsSingle } from '../../../../../../../../baseComponents/CreateRoutering/types'
import { ITLayoutTableModalOpenSetTy } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { OnChangeOrderTableLogicProps } from '../../../../OrderTable/useOrderTableHooks'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import useOrderTypeShippingDict from '../../../../../../../../utils/hooks/orders/useOrderTypeShippingDict'
import { Fragment, useCallback, useEffect, useState } from 'react'
import { parseAddressToOneLine } from '../../../../../../../../utils/globals/address'
import { twinFetchPostJSON, twinFetchPostText } from '../../../../../../../../utils/globals/data'
import TwinIcon, { TwinIconProp, TwinIconToolTip } from '../../../../../../../../baseComponents/TwinIcon'
import { TextAreaDebounce } from '../../../../../../../../forms/Input/TextArea'
import { flushSync } from 'react-dom'
import { getCurrencySymbol, prepareVatTag } from '../../../../../../../../utils/globals/price'
import { SellShippingTypePriceInversed } from '@teinor/erp/types/company/order/sell/sellShipping'
import { SellOrderTypeShippingInversed } from '@teinor/erp/types/company/order/sell/sellOrder'
import { BuyOrderTypeShippingInversed } from '@teinor/erp/types/company/order/buy/buyOrder'
import useBuyTypeShippingDict from '../../../../../../../../utils/hooks/buys/useBuyTypeShipping'

interface FooterConfigsComponentProps extends OnChangeOrderTableLogicProps {
    setOpenModal: ITLayoutTableModalOpenSetTy
    hideNotes: boolean | undefined
    userPermissions: UserPermissionsSingle
    modelId: string
    isReadOnly?: boolean
    headerData: TwinDictionary
    FooterOrderLeftConfigComponent: React.FC<FooterConfigShippingComponentBaseProps>
}

const FooterOrderLeftComponent: React.FC<FooterConfigsComponentProps> = ({ headerData, setOpenModal, hideNotes, userPermissions, isReadOnly, FooterOrderLeftConfigComponent, modelId, ...rest }) => {
    const permissionKey = Object.keys(userPermissions)?.[0]
    const haveUpdatePermission = permissionCheck(getUserPermissions(permissionKey as any), 'update')
    return (
        <div className={'footer_footer_left_configs_and_notes flex flex-auto flex-col '}>
            <h2 className='mb-10 regular16'><TwinTrans transKey='configsAndNotes'>Configuración y notas</TwinTrans></h2>
            <div className='flex flex-auto flex-col gap-y-10'>
                <FooterOrderLeftConfigComponent headerData={headerData} setOpenModal={setOpenModal} isReadOnly={isReadOnly} {...{ modelId}} />
                {(!hideNotes && haveUpdatePermission) ? <NotesOrderFooter {...rest} /> : null}
            </div>
        </ div>
    )
}

export interface FooterConfigShippingComponentBaseProps extends FooterConfigShippingComponentLogicProps { 
    setOpenModal: ITLayoutTableModalOpenSetTy
    modelId: string
    isReadOnly?: boolean
}

export const FooterConfigSellShippingComponent: React.FC<FooterConfigShippingComponentBaseProps> = ({ headerData, setOpenModal, modelId, isReadOnly }) => {
    const { t } = useTwinTranslation()
    const { dictTypeShipping, customerAddress, typeShipping, shipping } = useFooterConfigShippingComponentLogic({ headerData })
    const orderShippingData = headerData?.OrderShipping
    const textButtonShipping = !isReadOnly ? t('editShipping', 'Editar transporte') : t('seeShippingInfo', 'Ver información sobre el transporte')
    const textButtonPayment = !isReadOnly ? t('editPayment', 'Editar mét. de pago') : t('seePaymentInfo', 'Ver información sobre el mét. de pago')
    const renderShippingChildren: TwinDictionary[] = []
    const renderPaymentChildren: TwinDictionary[] = []
    
    if (shipping) {
        renderShippingChildren.push(
            {
                name: 'typeShipping',
                component: <ITHeaderText label={t('typeShipping', 'Tipo de envío')} value={dictTypeShipping[parseInt(String(headerData?.typeShipping))]?.name} />
            }
        )
        if (typeShipping === SellOrderTypeShippingInversed['sendToCustomer']) {
            if (customerAddress) {
                renderShippingChildren.push(
                    {
                        name: 'shippingAddress',
                        component: <ITHeaderText label={t('shippingAddress', 'Dirección de envio')} value={customerAddress} className='max-w-300' />,
                    },
                )
            }
            if (orderShippingData?.ShippingServiceId) {
                renderShippingChildren.push(
                    {
                        name: 'ShippingServiceId',
                        component: <ITHeaderText label={t('shippingServices', 'Servicio de Transportista')} value={headerData?.OrderShipping?.ShippingService?.ShippingCompany?.name + ' - ' + headerData?.OrderShipping?.ShippingService?.name} />,
                    },
                )
            }
            if (parseInt(orderShippingData?.typePrice) === SellShippingTypePriceInversed['introducePrice'] && !headerData?.hidePrices) {
                const name = headerData.OrderShipping.priceVatIncluded ? 'finalPriceWithTax' : 'initialPriceWithoutTax'
                renderShippingChildren.push(
                    {
                        name,
                        component: <ITHeaderText label={t('priceToCustomer', 'Precio cliente')} value={orderShippingData?.[name] + getCurrencySymbol(headerData.CurrencyId) + ' - ' + prepareVatTag(headerData?.OrderShipping?.priceVatIncluded, t)} />,
                    },
                )
            }
        }
    }
    if (headerData?.PaymentMethod || headerData?.PayMCopy) {
        renderPaymentChildren.push(
            {
                name: 'typePayment',
                component: <ITHeaderText label={t('typePayment', 'Tipo de mét. de pago')} value={headerData?.PayMCopy?.name || headerData?.PaymentMethod?.name} />
            }
        )
    }
    return (
        <Fragment>
            <SingleFooterConfigComponent icon={faTruck} text={shipping ? textButtonShipping : t('configShipping', 'Configurar transporte')} title={t('shipping', 'Transporte')} onClick={() => setOpenModal({ type: 'configShipping', allRowData: headerData })} children={renderShippingChildren} />
            <SingleFooterConfigComponent icon={faCreditCard} text={shipping ? textButtonPayment : t('configPaymentMethod', 'Configurar Mét. pago')} title={t('paymentMethod', 'Método de pago')} onClick={() => setOpenModal((modelId === 'SellInvoiceId' ? { type: 'configPaymentMethod', allRowData: { headerData, url: '/api/app/order/sell/sellInvoice/assignPaymentMethodToSellInvoice' } } : { type: 'configPaymentMethodSimple', allRowData: headerData }))} children={renderPaymentChildren} error={!headerData?.PayMCopy?.PayMCopyDates?.length ? 'Falta configurar' : undefined} />
        </Fragment>
    )
}

export const FooterConfigBuyShippingComponent: React.FC<FooterConfigShippingComponentBaseProps> = ({headerData, setOpenModal, isReadOnly }) => {
    const { t } = useTwinTranslation()
    const dictTypeBuyOrderShipping = useBuyTypeShippingDict()
    const dictTypeShipping = dictTypeBuyOrderShipping
    const { typeShipping, shipping } = useFooterConfigShippingComponentLogic({ headerData })
    const fieldPrice = headerData?.OrderShipping?.priceVatIncluded ? 'finalPriceWithTax' : 'initialPriceWithoutTax'
    const textButton = !isReadOnly ? t('editShipping', 'Editar transporte') : t('seeShippingInfo', 'Ver información sobre el transporte')
    const renderShippingChildren: TwinDictionary[] = []

    if (shipping) {
        renderShippingChildren.push(
            {
                name: 'typeShipping',
                component: <ITHeaderText label={t('typeShipping', 'Tipo de envío')} value={dictTypeShipping[parseInt(String(headerData?.typeShipping))]?.name} />
            }
        )
        if (typeShipping === BuyOrderTypeShippingInversed['sendToCustomer']) {
            if (headerData?.OrderShipping?.[fieldPrice]) {
                renderShippingChildren.push(
                    {
                        name: fieldPrice,
                        component: <ITHeaderText label={t('priceShipping', 'Precio transporte')} value={headerData?.OrderShipping?.[fieldPrice] + getCurrencySymbol(headerData.CurrencyId) + ' - ' + prepareVatTag(headerData?.OrderShipping?.priceVatIncluded, t) } className='max-w-300' />,
                    },
                )
            }
            if (headerData?.OrderShipping?.trackingId) {
                renderShippingChildren.push(
                    {
                        name: 'trackingId',
                        component: <ITHeaderText label={t('trackingNumber', 'N. seguimiento')} value={headerData?.OrderShipping?.trackingId} className='max-w-300' />,
                    },
                )
            }
        }
    }
    return (
        <SingleFooterConfigComponent icon={faTruck} text={shipping ? textButton : t('configShipping', 'Configurar transporte')} title={t('shipping', 'Transporte')} onClick={() => setOpenModal({ type: 'configShipping', allRowData: headerData })} children={renderShippingChildren} />
    )
}

interface FooterConfigShippingComponentLogicProps {
    headerData: TwinDictionary
}

const useFooterConfigShippingComponentLogic = ({ headerData }: FooterConfigShippingComponentLogicProps) => {
    const dictTypeSellOrderShipping = useOrderTypeShippingDict()
    const dictTypeShipping = dictTypeSellOrderShipping
    const [customerAddress, setCustomerAddress] = useState<string | null>(headerData?.OrderShipping?.ShippingAddressRelation ? parseAddressToOneLine(headerData?.OrderShipping?.ShippingAddressRelation) : null)
    const ShippingAddressId = headerData?.OrderShipping?.ShippingAddressId
    const typeShipping = headerData?.typeShipping
    const shipping = typeShipping === 0 || typeShipping

    const getAllCustomerAddress = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/customer/customerAddress/getCustomerAddressInstance', { 'id': ShippingAddressId })
        if (result) {
            setCustomerAddress(parseAddressToOneLine(result))
        }
    }, [setCustomerAddress, ShippingAddressId])

    useEffect(() => {
        if (!headerData?.OrderShipping?.ShippingAddressRelation && ShippingAddressId && permissionCheck(getUserPermissions('customer.profile.address'), 'read')) {
            getAllCustomerAddress()
        }
    }, [getAllCustomerAddress, headerData?.OrderShipping?.ShippingAddressRelation, ShippingAddressId])

    return { dictTypeShipping, customerAddress, typeShipping, shipping }
}

interface SingleFooterConfigComponentProps {
    icon: TwinIconProp
    title: string
    text: string
    onClick: () => void
    error?: string
    children?: TwinDictionary[]
}

const SingleFooterConfigComponent: React.FC<SingleFooterConfigComponentProps> = ({ icon, text, title, onClick, error, children }) => {
    const renderThis: JSX.Element[] = []
    for (const key in children) {
        const parsedKey = parseInt(key)
        const isLast = parsedKey === (children?.length - 1)
        const element = children[parsedKey]
        renderThis.push(
            <div key={element?.name} className={'single_config_row ' + (!isLast ? 'pr-10 border-r border-gray-D6' : '')}>{element?.component}</div>
        )
    }
    return (
        <div className='flex flex-col gap-y-15 single_footer_config_component rounded-lg py-10 px-15 bg-gray-F7'>
            <div className='flex justify-between flex-wrap items-center'>
                <div className='flex items-center medium14'>
                    <TwinIcon icon={icon} className='mr-8' />
                    <div>{title}</div>
                </div>
                <div className={'cursor-pointer flex items-center twin_elipsis single_footer_config_button_text ' + (error? 'text-yellow-B9': 'text-green-21')} onClick={onClick}>{text}
                    {error? <TwinIconToolTip className='ml-5' message={error} id={'error'+text} icon={faWarning} />: null}
                </div>
            </div>
            {renderThis?.length ? <div className='flex gap-15 mb-5 flex-wrap single_footer_config_body'>{renderThis}</div> : null}
        </div>
    )
}

interface NotesOrderFooterProps extends NotesOrderFooterLogicProps { }

const NotesOrderFooter: React.FC<NotesOrderFooterProps> = ({ ...rest }) => {
    const { updateNotes } = useNotesOrderFooterLogic({ ...rest })
    const { t } = useTwinTranslation()
    return (
        <TextAreaDebounce parentClassName='mt-auto' label={t('notes', 'Notas')} placeholder={t('writeYourNotes', 'Escribe tus notas')} onChange={updateNotes} value={rest?.completeData?.header['notes']} key={'notes'+rest.completeData?.header?.id} />
    )
}

interface NotesOrderFooterLogicProps extends OnChangeOrderTableLogicProps { }

const useNotesOrderFooterLogic = ({ setCompleteData, inputTableURLs }: NotesOrderFooterLogicProps) => {
    const updateNotes = useCallback(async (value: string) => {
        let result: TwinDictionary = {}
        await flushSync(() => {
            setCompleteData((oldData: any) => {
                if (!oldData) {
                    return null
                }
                oldData.header['notes'] = value
                result = { ...oldData.header }
                return { ...oldData }
            })
        })
        await twinFetchPostText(inputTableURLs.updateHeaderData, { id: result.id, notes: value })
    }, [inputTableURLs.updateHeaderData, setCompleteData])

    return { updateNotes }
}

export default FooterOrderLeftComponent